import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { DialogComponent } from 'src/app/components';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { LxmAppModule, UserAction } from 'src/app/enum';

@Component({
  selector: "subscription-restricted-dialog",
  host: { class: "dialog lexi-dialog" },
  templateUrl: "./subscription-restricted.dialog.html",
  styleUrls: ["./subscription-restricted.dialog.scss"],
})
export class SubscriptionRestrictedDialogComponent implements AfterViewInit {
  @ViewChild("dialog", { static: true, read: DialogComponent })
  private _dialog: DialogComponent;

  constructor(
    public dialogRef: MatDialogRef<SubscriptionRestrictedDialogComponent>,
    private _authService: AuthenticationService
  ) { }

  public ngAfterViewInit(): void { }

  public get canChangeSubscription() {
    return this._authService.hasRight([UserAction.ManageSettings]) && this._authService.hasModule(LxmAppModule.SellerPimExtensions);
  }

  // requiredRight: UserAction.ManageSettings, requiredModule: LxmAppModule.SellerPimExtensions

  public closeDialog() {
    this.dialogRef.close();
  }
}
